'use strict';

var React = require('react');

var SvgSidebarLeftMajor = function SvgSidebarLeftMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 3h3v-2h-3v2zm7-2a1 1 0 0 1 1 1v2h-2v-1h-1v-2h2zm1 17a1 1 0 0 1-1 1h-2v-2h1v-1h2v2zm-16.5 1h6.5v-18h-6.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5zm11.5 0h-3v-2h3v2zm5-5h-2v-3h2v3zm-2-5h2v-3h-2v3z"
  }));
};

exports.SvgSidebarLeftMajor = SvgSidebarLeftMajor;
